<template>
    <span v-if="item">
        <button type="button" @click="refreshUser()" class="btn btn-sm btn-warning">Refresh</button>
        <button type="button" @click="togglePaid()" :class="('btn-paid btn btn-sm btn-'+(item.isPaid?'danger':'primary'))">{{item.isPaid?'Make Unpaid':'Make Paid'}}</button>
        <button type="button" @click="togglePremium()" :class="('btn-premium btn btn-sm btn-'+(item.isPremium?'danger':'primary'))">{{item.isPremium?'Make unPremium':'Make Premium'}}</button>
        <button type="button" @click="toggleActive()" :class="('btn-active btn btn-sm btn-'+(item.isActive?'danger':'primary'))">{{item.isActive?'Disable':'Activate'}}</button>
        <br/>
        
        <!-- <button type="button" @click="toggleDelete()" :class="('btn-active btn btn-sm btn-'+(item.isDeleted?'primary':'danger'))">{{item.isDeleted?'UnDelete':'Delete'}}</button> -->
        <button type="button" @click="delCFMapping()" class="btn btn-sm btn-warning">Del Mapping</button>
        <button type="button" @click="toggleUsers()" :class="('btn-active btn btn-sm btn-'+(item.isUsersAccess?'warning':'primary'))">{{item.isUsersAccess?'Disable Users':'Enable Users'}}</button>
        <button type="button" @click="toggleTempDelete()" :class="('btn-active btn btn-sm btn-'+(item.isDeleted?'primary':'warning'))">{{item.isDeleted?'UnDelete':'Delete Temp'}}</button>
        <button v-if="item.isDeleted" type="button" @click="toggleDelete()" class="btn-active btn btn-sm btn-danger">Delete Per</button>
        <br/>
        
        
        <button type="button" v-if="item.mapFields && item.mapFields!='none'" @click="editFieldMapping()" class="btn btn-sm btn-primary">Edit Field Map</button>
        <button type="button" @click="delFieldMapping()" class="btn btn-sm btn-warning">Del Field Map</button>
        <button type="button" v-if="item.paymentsCount>0" @click="paymentsView()" class="btn btn-sm btn-primary">Payments</button>
        <button type="button" @click="extendTrial(null)" class="btn btn-sm btn-warning">Extend Trial</button>
        <button type="button" @click="extendTrial(-1)" class="btn btn-sm btn-warning">Unlimited</button>
    </span>
</template>
<style scoped>
    .btn{
        margin-bottom: 5px;
    }
    .btn-paid{
        min-width:110px;
    }
    .btn-premium{
        min-width:130px;
    }
    .btn-active{
        min-width:100px;
    }
</style>
<script>
import Vue from "vue";
import HttpFactory from '@/mixins/http.factory';
export default Vue.extend({
    mixins:[HttpFactory],	
    data() {
        return {
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        refreshUser(){
            const _self=this;
            _self.params.context.componentParent.refreshUser(_self.params);
        },
        togglePaid(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn(_self.params);
        },
        togglePremium(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn1(_self.params);
        },
        toggleUsers(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn6(_self.params);
        },
        toggleActive(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn2(_self.params);
        },
        toggleDelete(){
            const _self=this;
            _self.params.data.type='1';
            _self.params.context.componentParent.extraCallBackFn3(_self.params);
        },
        toggleTempDelete(){
            const _self=this;
            _self.params.data.type='0';
            _self.params.context.componentParent.extraCallBackFn3(_self.params);
        },
        paymentsView(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn4(_self.params);
        },
        delCFMapping(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn7(_self.params);
        },
        delFieldMapping(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn9(_self.params);
        },
        editFieldMapping(){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn10(_self.params);
        },
        extendTrial(trialExtendDays){
            const _self=this;
            let data=_self.params.data;
            if(trialExtendDays){
                data.trialExtendDays=trialExtendDays;
            } else {
                data.trialExtendDays = null;
            }
            _self.params.context.componentParent.extraCallBackFn8(data);
        },
    }
});
</script>
